import { useEffect, useState } from "react";
import PinInput from "react-pin-input";
import { useAppSelector } from "../../../globalState/hook";
import alert_message from "../../../Services/Alert/AlertMessage";
import AppAuthentication from "../../../Services/Authentication/AppAuthentication";

import LockSvg from "../../Extra/Svg/LockSvg";
import translator from "../../Extra/Translation/Translate";

const inputStyle = {
    borderColor: "white",
    border: "2px solid",
    borderRadius: "10px",
    color: "white",
};

const TwoFALogin = () => {
    const { authLoading } = useAppSelector((store) => store.auth);
    const { translate } = translator();

    const [token, setToken] = useState<string>("");
    const { verify2faToken, logoutAsync } = AppAuthentication();

    async function verify2FA() {
        try {
            const promise = verify2faToken(token);
            alert_message.promise("Verify 2fa ...", promise).catch(() => {
                setToken("");
            });
        } catch (error: any) {}
    }
    const handleConnexion = (e: any) => {
        e.preventDefault();
        verify2FA();
    };

    useEffect(() => {
        if (token.length === 6) {
            verify2FA();
        }
    }, [token]);

    return (
        <form
            onSubmit={(e) => handleConnexion(e)}
            className="bg-[#384146] auth-form opacity-90 shadow-lg z-10 rounded-xl px-4 md:!px-9 py-6 md:!py-8 space-y-6 w-full mx-auto"
        >
            <div className="mdg-twofa-cts">
                <div className="intro-x flex justify-center text-white">
                    {translate("SignIn", "Please_make_official_site")}
                </div>
                <div className="intro-x w-full mb-4 text-sm flex justify-center">
                    <span className="flex items-center justify-center to-bg-slate-200 rounded sm:w-[100%] lg:w-[55%] xl:w-[55%] 2xl:w-[55%] font-medium">
                        <LockSvg />
                        <span className="mt-1 text-white">
                            <span className="text-[#00AA4D]">https://</span>
                            clishanodes.com
                        </span>
                    </span>
                </div>
                <h2 className="intro-x  text-2xl font-bold  xl:text-3xl mt-8 text-center text-white">
                    {translate("SignIn", "2FA")}
                </h2>
                <div className="intro-x mt-8">
                    <div className="relative pin">
                        <PinInput
                            length={6}
                            initialValue={token}
                            onComplete={(value) => {
                                setToken(value);
                            }}
                            focus={true}
                            type="numeric"
                            inputMode="number"
                            style={{ padding: "10px", display: "flex" }}
                            inputStyle={inputStyle}
                            inputFocusStyle={{ borderColor: "white" }}
                            autoSelect={true}
                            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                        />
                    </div>
                </div>

                <div className="intro-x mt-5 flex justify-center text-center xl:mt-8 xl:text-left">
                    <button
                        className="btn btn-perfect align-top xl:mr-3 sm:w-32 lg:w-32 md:w-32 xl:w-32 2xl:w-32"
                        type="button"
                        onClick={() => logoutAsync()}
                        disabled={authLoading}
                    >
                        {translate("SignIn", "Cancel")}
                    </button>
                </div>
            </div>
        </form>
    );
};

export default TwoFALogin;
